import React from "react";
import axios from 'axios'
import "./styleLogin.css";
import { Redirect } from "react-router-dom";

// make to call to get user from redux or atom

export default class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount = async () => {
        await axios.get('/api/isLoggedIn')
        .then(({data}) => {
            if (data.loggedIn) {
                window.location = "/";
            }
        })
        
    }

    loginInfo = (e) => {
        e.preventDefault();
        const value = e.target.value
        const name = e.target.name
        this.setState({
            [name]: value
        })
    }

    onSubmit = (e) => {
        e.preventDefault();
        const loginObject = {
            email: this.state.email,
            password: this.state.password
        }
        axios.post('/userLogin', loginObject)
        .then(({data}) => {
            console.log(data)
            window.location = "/";
        })
        .catch(error => {
            console.log(error)
        })
    }

    registerRedirect = (e) => {
        e.preventDefault();
        window.location = "/register"
    }

    render() {
        return (
            <div class="container">
                <div class="screen">
                    <div class="screen__content">
                        <form class="login">
                            <div class="login__field">
                                <i class="login__icon fas fa-user"></i>
                                <input type="text" class="login__input" name='email' placeholder="User name / Email" onChange={(e) => this.loginInfo(e)} />
                            </div>
                            <div class="login__field">
                                <i class="login__icon fas fa-lock"></i>
                                <input type="password" class="login__input" name='password' placeholder="Password" onChange={(e) => this.loginInfo(e)} />
                            </div>
                            <div>
                                <button class="button login__submit" onClick={(e) => this.onSubmit(e)}>
                                    <span class="button__text">Log In Now</span>
                                    <i class="button__icon fas fa-chevron-right"></i>
                                </button>
                                <button class="button login__register " onClick={(e) => this.registerRedirect(e)}>
                                    <span class="button__text">Register</span>
                                    <i class="button__icon fas fa-chevron-right"></i>
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="screen__background">
                        <span class="screen__background__shape screen__background__shape4"></span>
                        <span class="screen__background__shape screen__background__shape3"></span>
                        <span class="screen__background__shape screen__background__shape2"></span>
                        <span class="screen__background__shape screen__background__shape1"></span>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/auth/login.js